'use client';
var createPrefixer = function(prefix) {
    var prefixed = function(raw) {
        return "" + prefix + raw;
    };
    var deprefixed = function(raw) {
        return String(raw).slice(String(prefix).length);
    };
    return {
        prefixed: prefixed,
        deprefixed: deprefixed
    };
};

export { createPrefixer };
